// Componente Skeleton para estados de carga con shimmer
export default function Skeleton({
  width,
  height,
  className = '',
  variant = 'rectangular',
  count = 1,
}) {
  const baseClasses = 'skeleton rounded-lg'

  const variantClasses = {
    rectangular: 'rounded-lg',
    circular: 'rounded-full',
    text: 'rounded h-4',
  }

  const style = {
    width: width || '100%',
    height: height || (variant === 'text' ? '1rem' : variant === 'circular' ? width : '2.5rem'),
  }

  // Si count > 1, generar múltiples skeletons (para listas)
  if (count > 1) {
    return (
      <div className="flex flex-col gap-3">
        {Array.from({ length: count }).map((_, i) => (
          <div
            key={i}
            className={`${baseClasses} ${variantClasses[variant]} ${className}`}
            style={style}
          />
        ))}
      </div>
    )
  }

  return (
    <div
      className={`${baseClasses} ${variantClasses[variant]} ${className}`}
      style={style}
    />
  )
}

// Skeleton predefinido para una tarjeta de predicción
Skeleton.Card = function SkeletonCard() {
  return (
    <div className="glass rounded-xl p-5 space-y-4">
      <div className="flex items-center gap-3">
        <Skeleton variant="circular" width="2.5rem" height="2.5rem" />
        <div className="flex-1 space-y-2">
          <Skeleton variant="text" width="60%" />
          <Skeleton variant="text" width="40%" />
        </div>
      </div>
      <Skeleton height="4rem" />
      <div className="flex gap-2">
        <Skeleton width="5rem" height="2rem" />
        <Skeleton width="5rem" height="2rem" />
      </div>
    </div>
  )
}

// Skeleton para fila de tabla de posiciones
Skeleton.LeaderboardRow = function SkeletonLeaderboardRow() {
  return (
    <div className="flex items-center gap-4 py-3 px-4">
      <Skeleton variant="text" width="1.5rem" />
      <Skeleton variant="circular" width="2rem" height="2rem" />
      <Skeleton variant="text" width="40%" className="flex-1" />
      <Skeleton variant="text" width="3rem" />
    </div>
  )
}
